

























import { Component, Vue, Prop } from "vue-property-decorator";
import ShakenCalendar from "@/components/ShakenCalendar.vue";
import SubHeader from "@/components/SubHeader.vue";
@Component({
  components: {
    SubHeader,
    ShakenCalendar
  }
})
export default class ReserveNext extends Vue {}
